import { useGetApiProjectsByProjectIdEtlSourcesQuery } from '@/model/etlSource/api.generated';
import { getSourceItemsFromDraft } from '@/model/etlSource/etlSource.model';
import { skipToken } from '@reduxjs/toolkit/query/react';

export const useEtlSourcesQuery = (projectId: string, pollingInterval = 0) => {
  const { data, isLoading, isError, error, refetch } = useGetApiProjectsByProjectIdEtlSourcesQuery(
    projectId ? { projectId } : skipToken,
    { pollingInterval, skipPollingIfUnfocused: true },
  );

  const sources = getSourceItemsFromDraft(data) ?? [];

  return {
    sources,
    isLoading,
    isError,
    error,
    refetch,
  };
};
